var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_core-js@2.5.1@core-js/library/modules/_html.js
// module id = 595
// module chunks = 0 1